import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import LoginForm from '../Authentication/LoginForm';
// import NoticeUploadForm from '../Authentication/NoticeUploadForm';
import NoticeList from '../Authentication/NoticeList';

const API_URL = 'https://noticebackend.onrender.com';

const Latest_information = () => {
  const [notices, setNotices] = useState([]);
  const [token, setToken] = useState('');

  // Fetch the notices from the backend
  const fetchNotices = async () => {
    try {
      const response = await axios.get(`${API_URL}/notices`);
      setNotices(response.data);
    } catch (error) {
      console.error('Error fetching notices:', error);
    }
  };


  useEffect(() => {
    fetchNotices();
  }, []);

  return (
    <div className="container">
      <NoticeList notices={notices} token={token} fetchNotices={fetchNotices} />
    </div>
  );
};

export default Latest_information;
